"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';

class BooleanOptionsFactory {
  async getOptions(_args) {
    return this.getOptionsSync();
  }
  getOptionsSync() {
    return [
      {
        label: "Yes",
        value: true,
        iconType: SvgIconType.ListOption
      },
      {
        label: "No",
        value: false,
        iconType: SvgIconType.ListOption
      }
    ];
  }
}

export { BooleanOptionsFactory };
